import { AddressDetails } from "../smart-components/smart-component-property";
import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";

export class ComponentAdapterLabelButton extends ComponentAdapterParent implements IComponentLoader {
    private _labelButtonDefaultImage: string = "";
    private _labelButtonOrientation: string = "";
    private _labelButtonAddressCommand: AddressDetails = null;
    private _labelButtonAddressState: AddressDetails = null;
    private _labelButtonIconsState: string = "";
    private _labelButtonFormatting: string = "";

    /**
     * Get the default image 
     */
    get LabelButtonDefaultImage(): string {
        return this._labelButtonDefaultImage;
    }

    /**
     * Get the orientation of image and text
     */
    get LabelButtonOrientation(): string {
        return this._labelButtonOrientation;
    }

    /**
     * Get the address command
     */
    get LabelButtonAddressCommand(): AddressDetails {
        return this._labelButtonAddressCommand;
    }

    /**
      * Get the address state
      */
    get LabelButtonAddressState(): AddressDetails {
        return this._labelButtonAddressState;
    }

    /**
      * Get the icons state string
      */
    get LabelButtonIconsState(): string {
        return this._labelButtonIconsState;
    }

    /**
      * Get the formatting string
      */
    get LabelButtonFormatting(): string {
        return this._labelButtonFormatting;
    }

    constructor() {
        super();
    }

    public fillProperty(listSmartComponentSkills: Array<SmartComponentPropertyDetails>): void {
        this._name = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LABEL_BUTTON_NAME)?.value || "";
        this._labelButtonDefaultImage = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LABEL_BUTTON_DEFAULT_IMAGE)?.value || "";
        this._labelButtonOrientation = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LABEL_BUTTON_ORIENTATION)?.value || "";
        this._labelButtonAddressCommand = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LABEL_BUTTON_ADDRESS_COMMAND)?.address || null;
        this._labelButtonAddressState = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LABEL_BUTTON_ADDRESS_STATE)?.address || null;
        this._labelButtonIconsState = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LABEL_BUTTON_ICONS_STATE)?.value || "";
        this._labelButtonFormatting = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LABEL_BUTTON_FORMATTING)?.value || "";

        this.fillMissingProperty();
        this.fillAddressState();
    }

    public fillMissingProperty(): void {
    }

    public fillAddressState(): void {
        if (this._labelButtonAddressState) {
            this._listSubscribeAddress.push(this._labelButtonAddressState);
        }

        //Push command address into array of subscription in order to get address with complete details
        if (this._labelButtonAddressCommand) {
            this._listSubscribeAddress.push(this._labelButtonAddressCommand);
        }
    }
}